import React from "react";
import ReactQuill from "react-quill";

let QUILL_EMPTY_CONTENT = "<p><br></p>";
let QUILL_EMPTY_CONTENT_REGEXP = /^<p[^>]*><br><\/p>$/;
let normalizeValue = (v) => (!v || v.match(QUILL_EMPTY_CONTENT_REGEXP) ? "" : v);

// TODO implement onFocus
// TODO implement onBlur
export default class FormattableTextAreaControl extends React.PureComponent {
  render() {
    const { name, value, onFocus, onBlur, onChange, id, ...rest } = this.props;

    return (
      <div className="FormattableTextAreaControl">
        <ReactQuill
          {...rest}
          theme="snow"
          name={name}
          value={value || QUILL_EMPTY_CONTENT}
          onFocus={onFocus}
          onChange={onChange && ((v) => onChange(normalizeValue(v)))}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/FormattableTextArea.jsx